import { cardContainerStyles as styles } from "@insite/content-library/Components/CardContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.cardDivider = {
    ...styles.cardDivider,
    css: css`
        ${styles.cardDivider?.css}
        border: 1px solid ${getColor(colorStrings.commonBorder)};

        /* Avoid using important */
        margin: -1px 0 0 !important;
        width: 100%;

        &:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }

        &:last-child {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    `,
};
